import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HeaderDropdownComponent } from '../../../header/header-dropdown/header-dropdown.component';
import { ApplicationStateService } from '../../../../../modules/application/shared/services/application-state/application-state.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-application-template-header',
    templateUrl: './application-template-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        AsyncPipe,
        MatToolbarModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        HeaderDropdownComponent,
    ],
})
export class ApplicationTemplateHeaderComponent {
    applicationState$ = this.applicationStateService.applicationState$;

    constructor(
        private readonly applicationStateService: ApplicationStateService,
    ) {}
}
